import React from 'react';

const styles = {
  container: {
    margin: '35px 0 25px',
    color: '#a1008f',
    textAlign: 'center'
  }
  
};

function HeaderSmall (props) {
  return (
    <div className="header-small" style={styles.container}>
      <div className="container">
        <h2>{props.title}</h2>
      </div>
    </div>
  );
}

export default HeaderSmall;